import script from "./mainLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./mainLayout.vue?vue&type=script&setup=true&lang=js"

import "./mainLayout.vue?vue&type=style&index=0&id=146b1e72&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146b1e72"]])

export default __exports__